exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".panel-group[data-v-69912a19],.panel[data-v-69912a19]{margin-bottom:0}.xxxuser-client[data-v-69912a19]{border:0 solid #d3d3d3;box-shadow:0 0 3px grey;margin-top:20px}h2 .fa[data-v-69912a19]{color:#337ab7}.cc-kombox-item[data-v-69912a19]{border-bottom:1px solid #d3d3d3;padding-top:5px;padding-bottom:5px}.cc-kombox-item[data-v-69912a19]:hover,.cc-memo-item[data-v-69912a19]:hover{background-color:#fcf8e3}.cc-kombox-list[data-v-69912a19],.cc-memo-list[data-v-69912a19]{height:100%;overflow:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-69912a19&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/UserClient.vue
// module id = 210
// module chunks = 0